module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "expect-job-detail",
    class: {
      'item-error': _vm.isError
    },
    on: {
      "click": _vm.showPopup
    }
  }, [_c('span', {
    staticClass: "name-tip",
    class: {
      'title-tip': _vm.hasSelected, 'error': _vm.isError
    }
  }, [_vm._v("期望职位")]), _vm._v(" "), _c('div', {
    staticClass: "selected-text"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasSelected),
      expression: "hasSelected"
    }]
  }, [_vm._v(_vm._s(_vm.selectedText))])])]), _vm._v(" "), _c('checklist', {
    key: _vm.checklistKey,
    attrs: {
      "data": _vm.titleList,
      "selects": _vm.selectedItems,
      "max": 5,
      "title": "选择期望职位（可多选）"
    },
    on: {
      "on-close": _vm.close,
      "on-confirm": _vm.confirm
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c3d5d4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/expectation/jobIntention/titleIntention.vue
// module id = 342
// module chunks = 0